var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.isCostsWithCashbackEnabled)?_c(_setup.CostsWithCashback,{attrs:{"data-testid":"costs-with-cashback-view"}}):(_setup.isCostsV2Enabled)?_c(_setup.Costs,{attrs:{"data-testid":"costs-view"}}):_c(_setup.CostsLegacy,{attrs:{"data-testid":"costs-legacy-view"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }